export const secure24Logo = '/assets/images/secure24-logo.svg';
